// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-appbar {
  z-index: 1300;
  height: 30px;
}
.my-appbar__toolbar {
  min-height: 48px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  display: flex;
  background-color: #ffffff;
  justify-content: space-between;
}
.my-appbar__toolbar__left {
  padding-left: 25px;
  display: flex;
  align-items: center;
  color: #000;
}
.my-appbar__toolbar__right {
  padding-right: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000;
}

.thongtintaikhoan__icon {
  color: #000;
}
.thongtintaikhoan__text {
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.02857em;
  opacity: 1;
  text-transform: none;
  vertical-align: unset;
  text-decoration: none;
  color: #000;
  font-weight: 400;
}

.name-account {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
}

.icon-noti {
  margin-right: 20px;
}
.icon-noti:hover {
  background-color: #ebf7e6;
}

.title-tc {
  color: #8F3232;
  font-size: 15px;
  font-weight: 400;
}

.title-pm {
  color: #2b713a;
  font-size: 15px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles/appbar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;AACJ;AAAI;EACI,2BAAA;EAGA,0BAAA;EACA,2BAAA;EACA,aAAA;EACA,yBAAA;EAEA,8BAAA;AADR;AAEQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAAZ;AAEQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAAZ;;AAKI;EACI,WAAA;AAFR;AAII;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AAFR;;AAKA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFJ;;AAIA;EACI,kBAAA;AADJ;AAEI;EACI,yBAAA;AAAR;;AAGA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AAAJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AACJ","sourcesContent":[".my-appbar {\r\n    z-index: 1300;\r\n    height: 30px;\r\n    &__toolbar {\r\n        min-height: 48px !important;\r\n        // padding-top: 5px;\r\n        // padding-bottom: 5px;\r\n        padding-left: 0 !important;\r\n        padding-right: 0 !important;\r\n        display: flex;\r\n        background-color: #ffffff;\r\n        // box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);\r\n        justify-content: space-between;\r\n        &__left {\r\n            padding-left: 25px;\r\n            display: flex;\r\n            align-items: center;\r\n            color: #000;\r\n        }\r\n        &__right {\r\n            padding-right: 25px;\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 10px;\r\n            color: #000;\r\n        }\r\n    }\r\n}\r\n.thongtintaikhoan {\r\n    &__icon {\r\n        color: #000;\r\n    }\r\n    &__text {\r\n        font-size: 16px;\r\n        line-height: 1.5;\r\n        letter-spacing: 0.02857em;\r\n        opacity: 1;\r\n        text-transform: none;\r\n        vertical-align: unset;\r\n        text-decoration: none;\r\n        color: #000;\r\n        font-weight: 400;\r\n    }\r\n}\r\n.name-account {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    color: #000000;\r\n}\r\n.icon-noti {\r\n    margin-right: 20px;\r\n    &:hover {\r\n        background-color: #ebf7e6;\r\n    }\r\n}\r\n.title-tc {\r\n    color: #8F3232;\r\n    font-size: 15px;\r\n    font-weight: 400;\r\n}\r\n.title-pm {\r\n    color: #2b713a;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
